import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-header-first-panel',
  templateUrl: './shared-header-first-panel.component.html',
  styleUrl: './shared-header-first-panel.component.scss',
  standalone: false,
})
export class SharedHeaderFirstPanelComponent {}
